import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Recipe } from 'api/menu/GetMenuIdV1';
import 'components/desktop/Menu/RecipeList/RecipeList.scss';
import RecipeListItem from 'components/desktop/Menu/RecipeList/RecipeListItem';
import AddToMenuOrRecipe from 'components/desktop/_general/AddMenuOrRecipe/AddMenuOrRecipe';
import BtnGroup, { BtnData } from 'components/desktop/_general/Button/BtnGroup/BtnGroup';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import Modal from 'components/desktop/_general/Modal/Modal';
import { usePermissions } from 'hooks/usePermissions';

interface IProps {
	addNewRecipe: () => void;
	menuId: string | null;
	recipes: Recipe[];
	selectedRecipe: number;
	setRecipes: (recipes: Recipe[]) => void;
	setSelectedRecipe: (index: number) => void;
	copy: boolean;
}

const RecipeList = (props: IProps) => {
	const { isMenuEditor } = usePermissions();
	const { t } = useTranslation();
	const [addItemModalVisible, setAddItemModalVisible] = useState<boolean>(false);

	const handleDelete = (index: number) => {
		const recipesCpy = [...props.recipes];
		recipesCpy.splice(index, 1);
		props.setRecipes(recipesCpy);
	};

	const setSelectedRecipe = (e: any, index: number) => {
		e.preventDefault();
		props.setSelectedRecipe(index);
	};

	const getButtonDataDelete = (input: number): BtnData | undefined => {
		if (isMenuEditor) {
			return {
				onClick: () => handleDelete(input),
			};
		}
	};

	const renderButtons = (index: number): JSX.Element => {
		return <BtnGroup delete={getButtonDataDelete(index)} />;
	};

	const renderContent = () => {
		return (
			<div className="row recipe-list-container" style={{ rowGap: '30px' }}>
				<Modal
					headerText={t('menu:ADD_RECIPE')}
					bodyContent={
						<AddToMenuOrRecipe
							sourceItemId={props.menuId}
							sourceItemType={props.copy ? 'menuCopy' : 'menu'}
							finalizeAdding={() => {
								setAddItemModalVisible(false);
							}}
						></AddToMenuOrRecipe>
					}
					isOpen={addItemModalVisible}
					headerIcon={<FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>}
					close={() => setAddItemModalVisible(false)}
					wide={true}
				></Modal>
				{props.recipes.map((element, index) => (
					<div className="col-xl-4 col-xxl-3 col-lg-4 col-md-6 col-sm-6" key={index}>
						<RecipeListItem
							buttons={renderButtons(index)}
							recipe={element}
							index={index}
							setSelectedRecipe={setSelectedRecipe}
							isActive={index === props.selectedRecipe}
						/>
					</div>
				))}
				<RenderIf condition={isMenuEditor}>
					<div className="col-xl-4 col-xxl-3 col-lg-4 col-md-6 col-sm-6">
						<div className="card recipe-card">
							<div className="card-body">
								<div
									className="card-picture-placeholder d-flex justify-content-center align-items-center"
									onClick={() => setAddItemModalVisible(true)}
									style={{ cursor: 'pointer' }}
								>
									<FontAwesomeIcon size="3x" icon={faPlusCircle} />
								</div>
							</div>
						</div>
					</div>
				</RenderIf>
			</div>
		);
	};

	return <>{renderContent()}</>;
};

export default RecipeList;
